<input
  #inputElement
  type="text"
  [placeholder]="placeholder"
  [value]="value | async"
  (input)="value.next($event.target.value)"
  (keydown)="keydown.emit($event)"
  [focusOnInit]="autoFocus"
  (focus)="fireFocusAnalyticEvent()"
  [disabled]="disabled | async"
  tabindex="0"
/>
<button
  (click)="value.next(''); focus()"
  [tabIndex]="(hasText | async) ? 0 : -1"
>
  <riv-icon
    [name]="(hasText | async) ? 'X' : 'Search'"
    [class.close]="hasText | async"
    [class.purp]="purp"
  ></riv-icon>
</button>
